<template>
  <div class="">
    <hr>
    <div class="my-2">
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">{{ item.type }}</span>
      <span class="badge badge-pill mx-2 badge-warning text-capitalize">شناسه: {{ item.id }}</span>
    </div>
    <div class="form-group">
      <input type="text" class="mb-2 form-control" v-model="item.title">
      <input type="text" class="mb-2 form-control" placeholder="slug دسته بندی" v-model="item.config['category_slug']">
    </div>

    <b-icon class="bg-danger d-inline p-1 rounded-pill mx-2 h3 text-white d-block my-2" icon="trash"
            @click="deleteQuestion()"/>
  </div>
</template>

<script>
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";

export default {
  name: "ChooseProductInput",
  props: {
    item: {}
  },
  computed: {
    generateHashComputed() {
      return generateHash()
    }
  },
  methods: {
    deleteQuestion() {
      this.$emit('removeQuestion')
    }
  }
}
</script>

<style scoped>

</style>